import { render } from "./SingleAddress.vue?vue&type=template&id=07afe2eb"
import script from "./SingleAddress.vue?vue&type=script&lang=js"
export * from "./SingleAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__